export interface BaseLinkItem {
  type?: string | null
  url?: string | null
  linkRef?: { value: string; entity: string; slug?: string | null } | string | null
  openInNewTab?: boolean | null
}

export const MAIN_MENU_CODE = 'main-header'
export const HORIZONTAL_MENU_CODE = 'Horizontal_Menu'

export function resolveNavLink(link?: BaseLinkItem | null): { url: string; isExternal: boolean } {
  if (!link) {
    return { url: '#', isExternal: false }
  }

  const isExternal = !!link.openInNewTab

  // If it's an internal reference from CMS (page, category, product, etc)
  if (link.type && link.linkRef) {
    const linkValue = typeof link.linkRef === 'object' ? link.linkRef.value : link.linkRef
    const linkEntity = typeof link.linkRef === 'object' ? link.linkRef.entity : link.type
    const linkSlug = typeof link.linkRef === 'object' ? link.linkRef.slug : null

    if (linkEntity === 'category') {
      return { url: `/categories/${linkValue}`, isExternal }
    }
    if (linkEntity === 'product') {
      return { url: `/products/${linkValue}`, isExternal }
    }

    // Default for 'page' or others — prefer slug for SEO-friendly URLs, fall back to id
    if (linkSlug) {
      return { url: `/${linkSlug}`, isExternal }
    }
    return { url: `/pages/${linkValue}`, isExternal }
  }

  // Fallback to URL
  if (link.url) {
    return { url: link.url, isExternal: link.url.startsWith('http') ? true : isExternal }
  }

  return { url: '#', isExternal: false }
}

/** Tailwind classes per part of `DesktopMegaMenu` (it adds the structural `p-*` classes itself). */
export interface MegaMenuClasses {
  root: string
  menu: string
  menuitem: string
  content: string
  label: string
  action: string
  panel: string
  grid: string
  column: string
  submenu: string
  submenuItem: string
  submenuIcon: string
}

export const MEGA_MENU_CLASSES: MegaMenuClasses = {
  root: 'w-full',
  menu: 'flex flex-col text-sm text-foreground',
  menuitem: 'relative group aria-expanded:bg-secondary/10',
  content: 'w-full flex',
  label: 'flex-1',
  action:
    'flex flex-1 items-center space-between w-full pl-4 pr-2 py-4 text-base font-semibold text-capitalize hover:bg-secondary/5 cursor-pointer',
  panel: 'bg-background border border-secondary/10 shadow-lg min-w-48',
  grid: 'flex w-full p-3',
  column: 'w-full',
  submenu: 'flex flex-col gap-1 text-sm text-foreground',
  submenuItem: '',
  submenuIcon: 'w-3.5 h-3.5',
}

export const MEGA_MENU_CLASSES_HORIZONTAL: MegaMenuClasses = {
  root: 'shrink-0',
  menu: 'flex items-center divide-x divide-secondary/20 text-sm text-foreground',
  menuitem: 'relative group px-4 first:pl-0 last:pr-0',
  content: 'flex',
  label: '',
  action:
    'flex items-center gap-1 py-1 text-foreground text-sm font-medium whitespace-nowrap underline-offset-8 decoration-2 decoration-transparent underline hover:text-primary-text hover:decoration-primary transition-colors cursor-pointer',
  panel: 'mt-2 bg-background border border-secondary/10 shadow-lg rounded-md min-w-52 z-50',
  grid: 'flex p-3',
  column: 'min-w-48',
  submenu: 'flex flex-col gap-1 py-1 group',
  submenuItem: '',
  submenuIcon: 'w-4 h-4 ml-1 opacity-60',
}
